import { styled } from "@mui/material/styles";
import { Box, Typography } from "@mui/material";

export const ForgotPasswordContainer = styled(Box)(() => ({
  width: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
}));

export const ForgotPasswordTitle = styled(Typography)(() => ({
  fontSize: "26px",
  fontStyle: "normal",
  fontWeight: 600,
  textAlign: "center",
  marginBottom: "16px",
}));

export const ForgotPasswordSubtitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  textAlign: "center",
  fontFamily: "Nunito",
  fontSize: "18px",
  fontStyle: "normal",
  fontWeight: 700,
  lineHeight: "32px",
  marginBottom: "44px",
}));

export const ForgotPasswordForm = styled(Box)(() => ({
  width: "100%",
  display: "flex",
  flexDirection: "column",
  gap: "44px",
}));

export const ForgotPasswordActions = styled(Box)(() => ({
  display: "flex",
  justifyContent: "center",
  gap: "24px",
  alignItems: "center",
}));
